module.exports = __webpack_public_path__ + "static/media/agenda.0c68c37f.png";